import { inject, Injectable, signal } from '@angular/core';
import { BehaviorSubject, catchError, concatMap, first, from, Observable, of, Subject, tap, toArray } from 'rxjs';
import { ReportFormPage } from './report-form-control.service';
import { LoaderService } from '@fdm/services';

export type ReportRequest = Observable<unknown>;

export interface ReportTask<T = string> {
  id?: number;
  page: T;
  request: ReportRequest;
}

@Injectable()
export class ReportsBulkSaveService {
  private _loader = inject(LoaderService);

  private _queue = signal<ReportTask[]>([]);

  public get queue() {
    return this._queue.asReadonly();
  }
  
  public saveComplete = new Subject<void>();

  includes(page: string) {
    const queue = this._queue();

    return queue.some(item => item.page === page);
  }

  add(task: ReportTask) {
    this._queue.update(items => [...items, task]);
  }

  remove(page: string) {
    this._queue.update(items => items.filter((item) => item.page !== page));
  }

  update({ page, request }: ReportTask) {
    this._queue.update(items => {
      const target = items.find((item) => item.page === page);
      
      if (target) {
        target.request = request;
      }

      return items;
    });

  }

  save() {
    const queue = this._queue();
    console.log('saving', queue);
    
    if (!queue.length) {
      this.saveComplete.next();
      return;
    }

    this._loader.startProcessing();
    
    from(queue)
      .pipe(
        concatMap((task) => {
          this.remove(task.page);
          
          return task.request.pipe(
            catchError(err => {
              // this._loader.stopProcessing();
              console.error(`Task ${task.page} failed`, err);
              return of(err);
            })
          )
        }),
        toArray()
      )
      .subscribe(() => {
        console.log('save completed', queue);
        
        this._loader.stopProcessing();
        this.saveComplete.next();
      });
  }
}
